export function initAccordions() {
	const accordions = document.querySelectorAll('.accordion');
	accordions.forEach(accordion => {
		const name = accordion.getAttribute('name');
		let siblings = [];
		if (name) {
			siblings = document.querySelectorAll('.accordion[name="' + name + '"]');
		}
		const summary = accordion.querySelector('.accordion-handle');
		summary?.addEventListener('click', e => {
			siblings.forEach(sibling => {
				if (!sibling.isEqualNode(accordion)) {
					sibling.classList.remove('open');
				}
			});
			accordion.classList.toggle('open');
			console.log('toggle');
		});
	});
}
